import { Breakpoints, enabledOnAllBreakpoints } from '../utilities';

export class ImosCollapse extends HTMLElement {
  private expanded = true;
  private enabled = false;
  private enabledOn: Array<keyof typeof Breakpoints> = enabledOnAllBreakpoints;
  private mediaQueries: { mql: MediaQueryList; handler: () => void }[] = [];

  connectedCallback(): void {
    this.expanded = this.getAttribute('expanded') !== 'false';

    const enabledOnAttr = this.getAttribute('enabled-on');
    if (enabledOnAttr) {
      this.enabledOn = enabledOnAttr
        .split(',')
        .map((s) => s.trim()) as Array<keyof typeof Breakpoints>;
    }

    const trigger = this.querySelector('[data-trigger]');
    trigger?.addEventListener('click', () => this.toggle());

    this.setupMediaQueries();
    this.checkIfEnabled();
    this.apply();
  }

  disconnectedCallback(): void {
    for (const { mql, handler } of this.mediaQueries) {
      mql.removeEventListener('change', handler);
    }
    this.mediaQueries = [];
  }

  private setupMediaQueries(): void {
    const breakpointKeys = Object.keys(Breakpoints)
      .filter((v) => isNaN(Number(v))) as Array<keyof typeof Breakpoints>;

    for (const key of breakpointKeys) {
      const mql = window.matchMedia(`(min-width: ${Breakpoints[key]}px)`);
      const handler = () => {
        this.checkIfEnabled();
        this.apply();
      };
      mql.addEventListener('change', handler);
      this.mediaQueries.push({ mql, handler });
    }
  }

  private checkIfEnabled(): void {
    const breakpoints = (
      Object.keys(Breakpoints).filter((v) => isNaN(Number(v))) as Array<
        keyof typeof Breakpoints
      >
    ).reverse();

    for (const breakpoint of breakpoints) {
      if (
        window.matchMedia(`(min-width: ${Breakpoints[breakpoint]}px)`).matches
      ) {
        this.enabled = this.enabledOn.includes(breakpoint);
        this.apply();
        return;
      }
    }
    this.enabled = false;
  }

  private toggle(): void {
    this.expanded = !this.expanded;
    this.apply();
  }

  private get isExpanded(): boolean {
    return this.expanded || !this.enabled;
  }

  private apply(): void {
    const content = this.querySelector('[data-collapsible]') as HTMLElement | null;
    const iconExpanded = this.querySelector('[data-icon-expanded]') as HTMLElement | null;
    const iconCollapsed = this.querySelector('[data-icon-collapsed]') as HTMLElement | null;
    const triggerArea = this.querySelector('[data-trigger]') as HTMLElement | null;

    if (content) {
      content.style.display = this.isExpanded ? '' : 'none';
    }

    if (iconExpanded) {
      iconExpanded.style.display = this.isExpanded ? '' : 'none';
    }
    if (iconCollapsed) {
      iconCollapsed.style.display = this.isExpanded ? 'none' : '';
    }

    // Hide toggle icons when collapse is disabled at current breakpoint
    const toggleIcons = triggerArea?.querySelector('[data-toggle-icons]') as HTMLElement | null;
    if (toggleIcons) {
      toggleIcons.style.display = this.enabled ? '' : 'none';
    }
  }
}

customElements.define('imos-collapse', ImosCollapse);
